export default __webpack_public_path__ + "static/media/logo-ADENE.1b952efd.png";